// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ff00ddd5","788":"7e21e4fd"}[chunkId] + ".chunk.js";
};